import {TemplateRef} from "@angular/core";

export interface DataTable {
  header: DataTableHeader;
  body: DataTableBody;
  footer?: DataTableFooter;
  customSelector?: string;
  parentValue?: string;
  useAlternateRows?: boolean;
  useFooterData?: boolean;
}

export enum DataTableRowItemType {
  Text = 'text',
  Template = 'template',
  Link = 'link',
  Checkbox = 'checkbox',
  Radio = 'radio',
  Input = 'input',
  Textarea = 'textarea',
  Select = 'select',
  ScrollLoad = 'scrollLoad',
  Button = 'button',
  SubText = 'subtext',
  Price = 'price'
}

export interface DataTableHeader {
  items: DataTableColumn[];
}

export interface DataTableBody {
  items: DataTableColumn[];
  rowClass?: DataTableClass[] | string;
}

export interface DataTableClass {
  func: Function;
  match: boolean;
  prop: string;
  cssClass: string;
}

export interface DataTableFooter {
  items: DataTableColumn[];
}

export interface DataTableColumn {
  key: string;
  value?: any;
  format?: string;
  useModel?: boolean;
  useParent?: boolean;
  template?: TemplateRef<any>,
  templateMobile?: TemplateRef<any>,
  type?: DataTableRowItemType;
  cssClass?: DataTableClass[] | string;
  colSpan?: number;
  rowSpan?: number;
  width?: number;
  isHidden?: boolean | Function;
  disabled?: boolean;
  action?: Function;
  children?: DataTableColumn[];
  buttons?: DataTableRowItemButton[];
  mobileHeaderItem?: boolean;
  inlineGrid?: boolean;
  inlineGridTemplate?: string;
  inlineGridSkipParent?: boolean;
  showCurrency?: boolean;
}

export interface DataTableRowItemButton {
  action: Function;
  value?: any;
  title?: string;
  isHidden?: boolean | Function;
  checkModel?: string;
  disabled?: boolean;
  tooltip?: string;
  icon?: string;
  color?: string;
  cssClass?: DataTableClass[] | string;
}
